import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { getPayMode, setPayMode } from "@/services/ccApi";

export const PayModeSwitch = () => {
  const [m, setM] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { getPayMode().then(setM).catch(() => {}); }, []);
  if (!m) return null;
  const live = m.mode === "live";
  const toggle = async () => {
    const next = live ? "test" : "live";
    const msg = next === "live" ? "Switch to LIVE? Customers will be charged real money." : "Switch to TEST? No real money will be collected.";
    if (!window.confirm(msg)) return;
    setBusy(true);
    try { const r = await setPayMode(next); setM({ ...m, ...r }); toast.success(`Razorpay now in ${next.toUpperCase()} mode`); }
    catch (e) { toast.error(e?.response?.data?.detail || e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-border bg-card px-3.5 py-2.5" data-testid="pay-mode-box">
      <div className="text-[11px] uppercase tracking-wide text-muted-foreground">Razorpay mode</div>
      <div className="flex items-center gap-2 mt-1">
        <span data-testid="pay-mode-label" className={`text-xs font-semibold px-2 py-0.5 rounded-full ${live ? "bg-emerald-500/15 text-emerald-500" : "bg-amber-500/15 text-amber-500"}`}>{live ? "LIVE" : "TEST"}</span>
        <Switch data-testid="pay-mode-switch" checked={live} disabled={busy} onCheckedChange={toggle} />
      </div>
      <p className="text-[10px] text-muted-foreground mt-1" data-testid="pay-mode-webhook">Webhook {m.webhook_configured ? "configured" : "secret pending"}</p>
    </div>
  );
};
